export class ProductAttribute {
  constructor(
    public readonly type: string,
    public readonly name: string,
    public readonly value: string
  ) { }
}

export enum AttributeIcon {
  Area = 'area_attr',
  Rooms = 'bedroom_attr',
  Bathroom = 'bathroom_attr',
  ParkingLots = 'parking_lots_attr',
  Stage = 'stage_attr',
  Suites = 'suite_attr'
}
